import '../Dashboard.css';

function Dashboard(){
    return (
      <>
      <section className="content" style={{ marginTop: '30px' }}>
        <div className="container-fluid dashboard-container">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card card-outline card-info">
                <div className="card-header-dashboards">
                  <h3 className="card-title"><i className="fa-solid fa-pen-to-square mr-1"></i>Dashboard - Estatísticas Vitais</h3>

                </div>
                {/* /.card-header-dashboards */}
                <div className=''>
                  <iframe src={'https://app.powerbi.com/view?r=eyJrIjoiMWYyNWZkNzAtNzRkYy00YjE2LTg2MzItNDg2ZDJkMWNhYjJkIiwidCI6Ijk1MzNkODg3LTAyNjQtNDAyZS05MjFiLTE0ZDk1ODgyZjQ0ZCJ9'} width={'100%'} height={'1000px'} title="Meu iframe"></iframe>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    </>
  );
}

export default Dashboard;